import * as types from './quartal.types';
import * as constants from './quartal.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const quartalReducer = generateResourceReducer<types.IQuartal>({
  STORE: constants.STORE_QUARTAL,
  CLEAR: constants.CLEAR_QUARTAL,
});
